module.exports = __webpack_public_path__ + "img/anti-whale.9bd4597e.svg";